module.exports = __webpack_public_path__ + "img/watermark.6c16d497.png";